import { useState } from 'react';

export const toPay = 'toPay';
export const toCancel = 'toCancel';

export type ChooseMode = 'toPay' | 'toCancel' | undefined;

export const useRequestsList = () => {
  const [chooseMode, setChooseMode] = useState<ChooseMode>();
  const [selectedCards, setSelectedCards] = useState<string[]>([]);

  const handleOnchangeChooseMode = (mode: ChooseMode) => {
    setChooseMode(mode);
    setSelectedCards([]);
  };

  const handleOnCheckCard = (checked: boolean, id: string) => {
    if (!checked && selectedCards.includes(id)) {
      setSelectedCards((prev) => prev.filter((x) => x !== id));
    } else if (checked) {
      setSelectedCards((prev) => [...prev, id]);
    }
  };

  return {
    chooseMode,
    selectedCards,
    handleOnCheckCard,
    handleOnchangeChooseMode,
  };
};
